import { useState, useEffect } from 'react';
import * as Yup from 'yup'
import {useFormik} from 'formik'
import { useNavigate } from 'react-router-dom';
import { FooterLogin, SideLogin } from './Login';

const passwordRules = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{5,}$/;

const validarDatos = Yup.object().shape({
    password: Yup.string()
      .min(5)
      .matches(passwordRules, { message: "Contraseña debil" })
      .required("Campo Requerido"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "No coinciden")
      .required("Campo Requerido"),
    token: Yup.number(),
})

const valorInicial = {
    password: '',
    confirmPassword: '',
    token: ''
}

////////////// COMPONENTE ////////////////
export default function NewPassword(){

    const [type, setType] = useState(false);
    // eslint-disable-next-line
    const [progress, setProgress] = useState(0);
    const navigate = useNavigate();



    const onSubmit = async (values) => {
        //console.log(values);
        navigate("/");
        await new Promise((resolve) => setTimeout(resolve, 1000));
    };

    const {
        values,
        errors,
        touched,
       // isSubmitting,
        handleBlur,
        handleChange,
        handleSubmit,
    } = useFormik({
        initialValues: valorInicial,
        validationSchema: validarDatos,
        onSubmit,
    });
    //console.log(values.password.length);

    useEffect(() => {
        let count = 0;
        if(values.password.length >= 5){
            count += 25;
            setProgress(count);
        }else{
            setProgress(count);
        }

        if(/[a-z]/.test(values.password) === true){
            count += 25;
            setProgress(count);
        }else{
            setProgress(count);
        }

        if(/[A-Z]/.test(values.password) === true){
            count += 25;
            setProgress(count);
        }else{
            setProgress(count);
        }

        if(/[0-9]/.test(values.password) === true){
            count += 25;
            setProgress(count);
        }else{
            setProgress(count);
        }
    },[values.password]);

    return(
        <>
        <div className="d-flex flex-column flex-root">
			<div className="d-flex flex-column flex-lg-row flex-column-fluid">
				<div className="d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1">
					<div className="d-flex flex-center flex-column flex-lg-row-fluid">
						<div className="w-lg-500px p-10">
							<form className="form w-100" onSubmit={handleSubmit}>
								<div className="text-center mb-10">
									<h1 className="text-dark fw-bolder mb-3">Nueva contraseña</h1>
									{/*<div className="text-gray-500 fw-semibold fs-6">Have you already reset the password?*/}
                                    {/*    <NavLink to="/" className="link-primary fw-bold">Sign in</NavLink>*/}
                                    {/*</div>*/}
								</div>
								<div className="fv-row mb-8">
									<div className="mb-1">
										<div className="position-relative mb-3">
                                            <div className="row">
                                                <div className="col-10 pe-0">
                                                    <input
                                                        name='password'
                                                        className={"form-control bg-transparent "+ (errors.password && touched.password ? "border-danger" : "")}
                                                        type={type ? 'text' : 'password'}
                                                        value={values.password}
                                                        placeholder='Contraseña'
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                    />
                                                </div>
                                                <div className="col-2 ps-0">
                                                    <button type="button" className="btn btn-icon btn-primary mx-3" onClick={() => setType(!type)}>
                                                        <i className="bi bi-eye-fill fs-4"></i>
                                                    </button>
                                                </div>
                                            </div>
                                            {errors.password && touched.password && <p className="text-danger mt-2">{errors.password}</p>}
										</div>
                                        {/*<ProgressBar now={progress} />*/}
									</div>
									{/*<div className="text-muted">Use 8 or more characters with a mix of letters, numbers & symbols.</div>*/}
								</div>
								<div className="fv-row mb-8">
                                    <input
                                        name='confirmPassword'
                                        className={"form-control bg-transparent " + (errors.confirmPassword && touched.confirmPassword ? "border-danger" : "")}
                                        type={type ? 'text' : 'password'}
                                        placeholder='Confirmar contraseña'
                                        value={values.confirmPassword}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                    {errors.confirmPassword && touched.confirmPassword && <p className="text-danger mt-2">{errors.confirmPassword}</p>}
								</div>
                                <div className='fv-row mb-8'>
                                    <div className="text-muted">Ingrese Token</div>
                                    <input
                                        className={"form-control bg-transparent " + (errors.token && touched.token ? "border-danger" : "")}
                                        name='token'
                                        placeholder='Token'
                                        type='number'
                                        value={values.token}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                    {errors.token && touched.token && <p className="text-danger mt-2">{errors.token}</p>}
                                </div>
								{/*<div className="fv-row mb-8">*/}
								{/*	<label className="form-check form-check-inline">*/}
								{/*		<input className="form-check-input" type="checkbox" name="toc" value="1" />*/}
								{/*		<span className="form-check-label fw-semibold text-gray-700 fs-6 ms-1">I Agree &*/}
                                {/*            /!*Cambiar button por Link *!/*/}
								{/*		    <button className="btn ms-1 link-primary">Terms and conditions</button>.*/}
                                {/*        </span>*/}
								{/*	</label>*/}
								{/*</div>*/}
								<div className="d-grid mb-10">
									<button type="submit" id="kt_new_password_submit" className="btn btn-primary">
										<span className="indicator-label">Enviar</span>
										<span className="indicator-progress">Please wait...
										<span className="spinner-border spinner-border-sm align-middle ms-2"></span></span>
									</button>
								</div>
							</form>
						</div>
					</div>
					<FooterLogin/>
				</div>
                <SideLogin/>
			</div>
		</div>
        </>
    );
}
